/*
 * @Author: Teemo Ding
 * @Date: 2021-07-15 10:13:31
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-02 17:33:44
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Payment/PaymentListPage/index.tsx
 */
import { NoDataPage } from '@/src/components';
import { Skeleton } from '@/src/components/Antd';
import EditableTable from '@/src/components/EditableTable/EditableTable';
import ErrorModal from '@/src/components/ErrorModal/ErrorModal';
import ErrorModalTitle from '@/src/components/ErrorModal/ErrorModalTitle';
import Layout from '@/src/layout/EditorPageLayout/EditorPageLayout';
import TopLeft from '@/src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import {
  deletePaymentGateway,
  getPaymentGatewayList,
  getPaymentGatewayProviders,
} from '@/src/request/settings/paymentGateway';
import {
  isUserValid,
  storeResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import { paymentGatewayProvider } from '@/src/types/common/paymentGateway';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { message } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import ModalHoc from 'src/constrains/ModalHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import ListPageLayout from 'src/layout/ListPageLayout/ListPageLayout';
import { i18nGet } from 'src/tools/tools';
import AddPaymentModal from '../../Components/AddPaymentModal/AddPaymentModal';
import { breadcrumbData, columns } from './config';

const permissions = () => {
  const add_edit_payment_gateway = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsPayment,
        operation: EnumOperation.add_edit_payment_gateway,
      }),
    ],
  });
  const delete_payment_gateway = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsPayment,
        operation: EnumOperation.delete_payment_gateway,
      }),
    ],
  });
  const view_payment_gateways_listing_page = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsPayment,
        operation: EnumOperation.view_payment_gateways_listing_page,
      }),
    ],
  });
  const view_payment_gateway_details = isUserValid({
    source: EPermissionSource.store,
    resourcesGroup: [
      storeResourceNameGenerator({
        category: EnumCategory.Settings,
        subCategory: EnumSubCategory.SettingsPayment,
        operation: EnumOperation.view_payment_gateway_details,
      }),
    ],
  });
  return {
    add_edit_payment_gateway,
    delete_payment_gateway,
    view_payment_gateways_listing_page,
    view_payment_gateway_details,
  };
};
const PaymentListPage = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const {
    add_edit_payment_gateway,
    delete_payment_gateway,
    view_payment_gateways_listing_page,
    view_payment_gateway_details,
  } = permissions();
  const {
    modalOp: { setShowModal, setModalTitle, setModalContent },
  } = props;
  const [loading, setLoading] = useState(true);
  const [paymentList, setPaymentList] = useState([]);
  const history = useHistory();
  const [providers, setProviders] = useState([]);

  useEffect(() => {
    if (view_payment_gateways_listing_page) {
      const getPaymentGatewayListReq = getPaymentGatewayList();
      const getPaymentGatewayProvidersReq = getPaymentGatewayProviders();
      Promise.all([
        getPaymentGatewayListReq,
        getPaymentGatewayProvidersReq,
      ]).then((res: any) => {
        setPaymentList(res[0] || []);
        setProviders(res[1] || []);
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, []);

  const handleAddConfirm = (newProvider) => {
    const params = (paymentList || []).filter((o) => {
      return o?.gatewayProvider.code == newProvider;
    });
    history.push(
      `/settings/payment/edit/${newProvider}?length=${
        params.length ? params.length + 1 : 1
      }`,
    );
  };

  const addFun = () => {
    const _p = providers.filter((i) => i.code !== paymentGatewayProvider.ADYEN);
    const defaultRadioItem = _p.map((provider) => {
      const supportedPaymentMethods = provider.supportedPaymentMethods.map(
        (item) => item.name,
      );
      return {
        label: '',
        value: provider.code,
        disable: false,
        image: provider.icon.url,
        description: `${getI18n(
          'storePayment.paymentListPage.availablepaymentmethods',
        )}: ${supportedPaymentMethods.join(' , ')}`,
        title: provider.name,
      };
    });
    setShowModal(true);
    setModalTitle(getI18n('storePayment.paymentListPage.addpaymentgateway'));
    setModalContent(
      <AddPaymentModal
        setShowModal={setShowModal}
        defaultRadioItem={defaultRadioItem}
        paymentList={paymentList}
        inputPlaceHolder={getI18n(
          'storePayment.paymentListPage.addpaymentgatewayplaceHolder',
        )}
        onConfirm={handleAddConfirm}
      />,
    );
  };
  const pageLayoutProps = {
    title: getI18n('storePayment.paymentListPage.paymentGateways'),
    addText: add_edit_payment_gateway
      ? getI18n('storePayment.paymentListPage.addPaymentGateway')
      : '',
    addFun,
    activeKey: '',
    tabsConfig: [{ name: getI18n('general.all'), key: '' }],
  };
  const editAction = (record) => {
    history.push(
      `/settings/payment/edit/${record.gatewayProvider.code}/${record.uuid}`,
    );
  };

  const handleDeletePaymentGateway = (record) => {
    deletePaymentGateway(record.uuid).then(() => {
      message.success(getI18n('general.deletedsuccessfully'));
      getPaymentGatewayList().then((data) => {
        setPaymentList(data || []);
      });
    });
  };

  const deleteAction = (record) => {
    setShowModal(true);
    setModalTitle(
      <ErrorModalTitle>
        {getI18n('storePayment.paymentListPage.deletePaymentGateway')}
      </ErrorModalTitle>,
    );
    setModalContent(
      <ErrorModal
        setModal={setShowModal}
        onSubmit={() => handleDeletePaymentGateway(record)}
        okText={getI18n('general.delete')}
        errorText={getI18n(
          'storePayment.paymentListPage.deletePaymentGatewayErrorText',
        )}
      />,
    );
  };
  const child = [
    {
      child: (
        <div>
          {paymentList.length == 0 ? (
            <NoDataPage
              title={getI18n(
                'storePayment.paymentListPage.addPaymentGatewayTitle',
              )}
              introduce={getI18n(
                'storePayment.paymentListPage.addPaymentGatewayIntroduce',
              )}
              buttonTitle={getI18n(
                'storePayment.paymentListPage.addPaymentGateway',
              )}
              onClick={addFun}
              disabled={!add_edit_payment_gateway}
            />
          ) : (
            <ListPageLayout {...pageLayoutProps}>
              <EditableTable
                disableAdd
                data={paymentList}
                columns={columns(
                  editAction,
                  deleteAction,
                  !view_payment_gateway_details,
                  !delete_payment_gateway,
                  { getI18n },
                )}
                id='PaymentListTable'
                rowKey='uuid'
              />
            </ListPageLayout>
          )}
        </div>
      ),
    },
  ];

  const goBackToList = () => {
    history.push({
      pathname: '/settings',
    });
  };

  const topLeft = (
    <TopLeft
      goBack={goBackToList}
      breadcrumbData={breadcrumbData({ getI18n })}
    />
  );
  return (
    <Skeleton loading={loading} active>
      <Layout elements={child} topLeft={topLeft}></Layout>
    </Skeleton>
  );
};

export default ModalHoc(PaymentListPage);
